import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'

import styles from 'src/styles/common.module.scss'

export const TextHeaderEl = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <HighlightedText
            text="ΓΥΡΙΣΤΕ ΤΟΝ ΤΡΟΧΟ ΚΑΙ ΚΕΡΔΙΣΤΕ ΔΩΡΕΑΝ ΠΕΡΙΣΤΡΟΦΕΣ"
            highlights={[{ word: 'ΔΩΡΕΑΝ' }, { word: 'ΠΕΡΙΣΤΡΟΦΕΣ' }]}
            breakAfterWords={isDesktop ? ['ΚΕΡΔΙΣΤΕ'] : ['ΤΡΟΧΟ', 'ΚΕΡΔΙΣΤΕ']}
            className={styles.text_header}
        />
    )
}
